import React from "react";
// import { decodeToken } from "react-jwt";
import { Navigate } from "react-router-dom";
import { useLoginContext } from "../context/loginContext";
import { role, menuListOW, menuListAdminStaf, menuListTeknisiKoordinator, menuListTeknisiStaf } from "../utils/globalVariables";
import { safetyDecodeJWT } from "../utils/globalFunctions";
import LoginIndex from "../pages/login/LoginIndex";

const LoginRoute = () => {

  const { loginContext } = useLoginContext();

  try {
    if (safetyDecodeJWT(loginContext, 'syswebapp', 'syswebappsl') === role.owner.subLevel.owner.slugSubLevel) {
      return <Navigate
        to={`/${role.owner.subLevel.owner.slugLink}/project/${menuListOW.project.subMenu.zero.flag}/${menuListOW.project.subMenu.zero.tabs.one.flag}`}
        replace={true}
      />
    } else if (safetyDecodeJWT(loginContext, 'syswebapp', 'syswebappsl') === role.teknisi.subLevel.teknisi_kepala.slugSubLevel) {
      return <Navigate
        to={`/${role.teknisi.subLevel.teknisi_kepala.slugLink}/project/${menuListTeknisiKoordinator.project.subMenu.zero.flag}/${menuListTeknisiKoordinator.project.subMenu.zero.tabs.one.flag}`}
        replace={true}
      />
    } else if (safetyDecodeJWT(loginContext, 'syswebapp', 'syswebappsl') === role.teknisi.subLevel.teknisi_staf.slugSubLevel) {
      return <Navigate
        to={`/${role.teknisi.subLevel.teknisi_staf.slugLink}/project/${menuListTeknisiStaf.project.subMenu.zero.flag}/${menuListTeknisiStaf.project.subMenu.zero.tabs.one.flag}`}
        replace={true}
      />
    } else if (safetyDecodeJWT(loginContext, 'syswebapp', 'syswebappsl') === role.admin.subLevel.admin_staf.slugSubLevel) {
      return <Navigate
        to={`/${role.admin.subLevel.admin_staf.slugLink}/project/${menuListAdminStaf.project.subMenu.one.flag}/${menuListAdminStaf.project.subMenu.one.tabs.one.flag}`}
        replace={true}
      />
    }

    // else if (safetyDecodeJWT(loginContext, 'syswebapp', 'syswebappsl') === role.admin.subLevel.admin_kepala.slugSubLevel) {
    //     return <Navigate
    //         to={`/${role.admin.subLevel.admin_kepala.slugLink}/project/${menuListOW.project.subMenu.one.flag}/${menuListOW.project.subMenu.one.tabs.one.flag}`}
    //         replace={true}
    //     />
    // }

    // else if (safetyDecodeJWT(loginContext, 'syswebapp', 'syswebappsl') === subLevelSlugSPV) {
    //     return <Navigate to={`/${linkSlugSPV}/${mnSPVPermintaanBarang}`} replace={true} />
    // } else if (safetyDecodeJWT(loginContext, 'syswebapp', 'syswebappsl') === subLevelSlugAS1) {
    //     return <Navigate to={`/${linkSlugAS1}/${mnAS1PermintaanBarang}`} replace={true} />
    // } else if (safetyDecodeJWT(loginContext, 'syswebapp', 'syswebappsl') === subLevelSlugAS2) {
    //     return <Navigate to={`/${linkSlugAS2}/${mnAS2PermintaanBarang}`} replace={true} />
    // }

    else {
      return <LoginIndex />;
    }
  } catch (error) {
    return <LoginIndex />;
  }
}

export default LoginRoute;